export enum Permission {
  ShiftsView = 'partner_pick.view',
  ShiftsModify = 'partner_pick.modify',
}
